export type CrypptoMerchantURLOptions= {
  BusinessStatus?: number,
  sellerType?: string,
  isBlock?: boolean,
}

export const crypptoMerchantURL = (options?: CrypptoMerchantURLOptions) => {
  if (`${options?.BusinessStatus}` === '1') {
    if (options?.sellerType === "Business") {
      // 卖家为商家，买家也为商家
      return "Business";
    } else {
      // 买家不为商家，买家为商家
      return "";
    }
  } else {
    if (options?.sellerType === "Business") {
      // 卖家为商家，买家不为商家
      return "Business";
    } else {
      // 卖家不为商家，买家不为商家
      return "";
    }
  }
  return "";
};